export default __webpack_public_path__ + "static/media/video-pause.13316bc0.svg";